import React, { useEffect, useState } from "react";
import "./CoverPage.css";
import HardRefresh from "./../../components/ReusableComponents/HardRefresh/HardRefresh";
import { getUserDetails } from "../../utils/authUtils";
import { fetchImageUrl } from "../../network/api";
const CoverPage = ({ coverPageData = {}, activeDashboard, setForceRefresh }) => {
  const [signedUrl, setSignedUrl] = useState(null);
  const { selectedColor, customRadio, image } = coverPageData || {};

  const getSignedUrl = async () => {
    if (image?.imageKey) {
      const response = await fetchImageUrl(image?.imageKey);
      setSignedUrl(response);
    }
  };

  useEffect(() => {
    getSignedUrl();
  }, [coverPageData]);

  const headerStyle = {
    background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),${selectedColor || "rgb(var(--ng-neutral-70))"}`,
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ${
      customRadio === "image" ? `url(${signedUrl})` : "none"
    }`,
  };
  const userDetails = getUserDetails() || {};
  const heading = (coverPageData?.heading || "")
    .replace("@{User:FullName,}", userDetails?.FullName || "")
    .replace("@{User:FirstName,}", userDetails?.FirstName || "")
    .replace("@{User:LastName,}", userDetails?.LastName || "")
    .replace("@{User:MiddleName,}", userDetails?.MiddleName || "");

  const description = (coverPageData?.description || "")
    .replace("@{User:FullName,}", userDetails?.FullName || "")
    .replace("@{User:FirstName,}", userDetails?.FirstName || "")
    .replace("@{User:LastName,}", userDetails?.LastName || "")
    .replace("@{User:MiddleName,}", userDetails?.MiddleName || "");

  return (
    <div className="welcome-banner" style={headerStyle}>
      <HardRefresh
        setForceRefresh={setForceRefresh}
        key={activeDashboard?.id}
        activeDashboardId={activeDashboard?.id}
      />
      <div className="welcome-container ">
        <div className="heading ng_d_4_m" title={heading ?? ""}>
          {heading || `Welcome ${userDetails?.FirstName || ""}`}
        </div>
        <p className="description" title={description ?? ""}>
          {description || "Gear up for today, check up on KPIs and required follow-ups"}
        </p>
      </div>
    </div>
  );
};

export default CoverPage;
